import { render, staticRenderFns } from "./afterClassQA.vue?vue&type=template&id=9fadea7c&scoped=true"
import script from "./afterClassQA.vue?vue&type=script&lang=js"
export * from "./afterClassQA.vue?vue&type=script&lang=js"
import style0 from "./afterClassQA.vue?vue&type=style&index=0&id=9fadea7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fadea7c",
  null
  
)

export default component.exports